import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/threads-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/threads" });
	},
});
